import { AppState } from 'store';
import memoize from 'fast-memoize';

/** Function used to memoize selectors */
export function memoizeSelectorFactory<PropsType, ResultType = any>(
  factoryFn: (props: PropsType) => (appState: AppState) => ResultType
): (props: PropsType) => (appState: AppState) => ResultType {
  return memoize(factoryFn);
}
